export const localeSpanish = {
    lang: 'es',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'CATALOGOS': 'Catalogs',
            'ADMINISTRACION_RAMOS': {
                'TITLE': 'Ramos'
            },
            'ADMINISTRACION_AGENTES': {
                'TITLE': 'Agentes'
            },
            'ADMINISTRACION_COMPANIAS': {
                'TITLE': 'Compañías'
            },
            'ADMINISTRACION_COBERTURAS': {
                'TITLE': 'Coberturas'
            },
            'ADMINISTRACION_CLIENTES': {
                'TITLE': 'Clientes'
            },
            'ADMINISTRACION_SUCURSALES': {
                'TITLE': 'Sucursales'
            },
            'ADMINISTRACION_GRUPOS': {
                'TITLE': 'Grupos'
            },
            'TIPOCAMBIO': 'TipoCambio',
            'ADMINISTRACION_TIPOCAMBIO': {
                'TITLE': 'Tipo de Cambio'
            },
            'ADMINISTRACION_USUARIOS': {
                'TITLE': 'Usuarios'
            },
            'INTERFACES_POLIZAS': {
                'TITLE': 'Carga de Pólizas y Endosos'
            },
            'INTERFACES_COBRANZAS': {
                'TITLE': 'Carga de Cobranzas'
            },
            // 'INTERFACES_ENDOSOS': {
            //     'TITLE': 'Carga de Endosos'
            // }, 
            'ADMINISTRACION_ORDENES_TRABAJO': {
                'TITLE': 'Ordenes de Trabajo'
            },
            'ADMINISTRACION_CAPTURA_POLIZA': {
                'TITLE': 'Captura de Polizas'
            },
            'ADMINISTRACION_CAPTURA_COBRANZA': {
                'TITLE': 'Captura de Cobranzas'
            },
            'ADMINISTRACION_CAPTURA_ENDOSOS': {
                'TITLE': 'Captura de Endosos'
            },
            'ADMINISTRACION_CAPTURA_SINIESTROS': {
                'TITLE': 'Captura de Siniestros'
            },
            'ADMINISTRACION_CONSULTA_POLIZA': {
                'TITLE': 'Consulta de Polizas'
            },
            'REPORTES_CONTROLCARTERA_POLIZASPAGADAS': {
                'TITLE': 'Polizas Pagadas'
            },
            'REPORTES_CONTROLCARTERA_POLIZASPORCOBRAR': {
                'TITLE': 'Polizas Por Cobrar'
            },
            'REPORTES_CONTROLCARTERA_POLIZASPORRENOVAR': {
                'TITLE': 'Polizas Por Renovar'
            },
            'REPORTES_CONTROLCARTERA_POLIZASRENOVADAS': {
                'TITLE': 'Polizas Renovadas'
            },
            'REPORTES_CONTROLCARTERA_POLIZASENDEPOSITO': {
                'TITLE': 'Polizas En Deposito'
            },
            'REPORTES_CONTROLCARTERA_PRODUCCION': {
                'TITLE': 'Produccion'
            },
            'REPORTES_CONTROLCARTERA_ESTADODECLIENTE': {
                'TITLE': 'Estado de Cliente'
            },
            'REPORTES_CONTROLCARTERA_COMISIONES': {
                'TITLE': 'Comisiones'
            },
            'REPORTES_CONTROLCARTERA_RECORDATORIOS': {
                'TITLE': 'Recordatorios'
            },
            'REPORTES_CONTROLCARTERA_SOLICITUDES': {
                'TITLE': 'Solicitudes'
            },
            'REPORTES_CONTROLCARTERA_GENERALPOLIZAS': {
                'TITLE': 'General Polizas'
            },
            'REPORTES_CONTROLCARTERA_CLIENTES': {
                'TITLE': 'Clientes'
            }

        }
    }
}; 